let isRTLCache: boolean | null = null;

export function isRTL(): boolean {
    if (isRTLCache !== null) {
        return isRTLCache;
    }

    isRTLCache = document.documentElement.getAttribute('dir') === 'rtl';

    return isRTLCache;
}
